
export default {
  props: {
    name: {
      type: String,
      default: () => '',
    },
    beneficios: {
      type: String,
      default: () => '',
    },
  },
}
